module.exports = __webpack_public_path__ + "static/img/logo.11213d5b.png";